/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateControlReate from 'components/ControlRate/controlRate.create';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const ControlReateCreatePage = () => {
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   let id = null;
   if (location?.pathname.includes('edit')) {
      id = Number(locationSplit[4]);
   }

   return (
      <Fragment>
         <Helmet>
            <title>{id ? 'แก้ไขข้อมูลควบคุมยอดตั้งสู้สมาชิก' : 'สร้างข้อมูลควบคุมยอดตั้งสู้สมาชิก' }</title>
         </Helmet>
         <HasAccess
            roles={['Owner','Senior','Master','Agent']}
            permissions={['payrate-create']}
            renderAuthFailed={<ErrorPage404 />}
         >
            <Card title={`${id ? 'แก้ไขข้อมูลควบคุมยอดตั้งสู้สมาชิก' : 'สร้างข้อมูลควบคุมยอดตั้งสู้สมาชิก' }`}>
               <CreateControlReate id={Number(id)}/>
            </Card>
         </HasAccess>
      </Fragment>
   );
};

export default ControlReateCreatePage;
